import { render, staticRenderFns } from "./payPage.vue?vue&type=template&id=710cee08"
import script from "./payPage.vue?vue&type=script&lang=js"
export * from "./payPage.vue?vue&type=script&lang=js"
import style0 from "./payPage.vue?vue&type=style&index=0&id=710cee08&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports